import {
  AppHeader,
  AppHeaderBackButton,
  Box,
  Button,
  Container,
  Stack,
  Typography,
  Alert,
  Icon,
  ButtonGroup,
} from '@ace-clublabs/shared-component-library';
import { useGlobalState } from '../state/state';
import { useHistory } from 'react-router-dom';
import { Pages } from '../utils/constants';
import { onDownloadPDFCard } from '../utils/getMembershipPDF';
import { IRequestPlasticCardRequest } from '@lib/types';
import { sources } from '../api/sources';
import { useEffect, useLayoutEffect, useState } from 'react';
import { UtagHelper, UtagType } from '../utils/UtagHelper';
import { isAllowedToOrder } from '../utils/rules';
import { LoadingView } from '../components/LoadingView/LoadingView';

export const RequestPlasticCard: React.FC = () => {
  const history = useHistory();
  const [isMobileApp] = useGlobalState('isMobileApp');
  const [memberDetails, setMemberDetails] = useGlobalState('memberDetails');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isTagging, setTagging] = useState(true);
  const [tags] = useGlobalState('tags');
  const memberId =
    memberDetails.selectedCustomerId === '' ? memberDetails.loggedInCustomerId : memberDetails.selectedCustomerId;
  const loggedInMember = memberDetails?.members?.find((m) => m.customerId === memberDetails?.loggedInCustomerId);
  const member = memberDetails?.members?.find((m) => m.customerId === memberId);
  const [finishLoadingProps, setFinishLoadingProps] = useState({ finished: true, onFinish: () => {} });

  useEffect(() => {
    if (!member || member?.plasticReplacementCard?.eligible == false) {
      history.push(Pages.HomePage);
      return;
    }
    return;
  }, []);

  useLayoutEffect(() => {
    UtagHelper.sendTag(UtagType.view, tags, 'plastic card', {});
    setTagging(false);
  }, []);

  if (isTagging) {
    return <></>;
  }

  // precompute pdf ahead of time
  const onPDFdownloadCallback = (async () => {
    return await onDownloadPDFCard(memberDetails);
  })();

  const onRequestPDFCard = async () => {
    UtagHelper.sendTag(UtagType.link, tags, 'plastic card', {
      cta: 'my account:account maintenance:replacement card:plastic card-download pdf',
    });
    (await onPDFdownloadCallback)();
  };
  const onRequestPlasticCard = async () => {
    setFinishLoadingProps({ finished: false, onFinish: () => {} });
    UtagHelper.sendTag(UtagType.link, tags, 'plastic card', {
      cta: 'my account:account maintenance:replacement card:plastic card-request card',
    });
    const request: IRequestPlasticCardRequest = {
      CustomerId: member?.customerId ?? '',
    };
    const response = await sources.requestCard(request);
    setFinishLoadingProps({ finished: true, onFinish: () => {} });
    if (response && response.status != 'success') {
      history.push(Pages.SorryPage);
    } else {
      if (member) {
        member.plasticReplacementCard.eligible = false;
        setMemberDetails(memberDetails);
      }
      history.push(Pages.Confirmation);
    }
  };

  return (
    <Container maxWidth="sm">
      {!finishLoadingProps.finished ? (
        <LoadingView estimatedTimeInSeconds={5} finishProps={finishLoadingProps} message="Processing your request" />
      ) : (
        <Box>
          <AppHeader backButton={!isMobileApp && <AppHeaderBackButton />} sx={{ padding: '0 !important' }} />
          <Stack marginTop="1rem">
            <Typography variant="h5Medium" className="plastic-card-title">
              Request a plastic replacement card
            </Typography>
            <Typography variant="b1Regular" className="plastic-card-description" marginTop="0.5rem" lineHeight="1.5rem">
              <ul className="plastic-card-bullet">
                <li>You can make 2 requests for a plastic replacement card each membership year.</li>
                <li>Only 1 replacement card may be requested within a 7-day period.</li>
                <li>Replacement cards will be processed and mailed in 15-20 business days.</li>
              </ul>
            </Typography>
            <Alert
              severity="success"
              className="download-digital-card-banner"
              displayCloseButton={false}
              sx={{ marginTop: '1rem', background: '#E9F7DB' }}
              icon={<Icon iconName="leaf-regular" />}
            >
              <Typography variant="b2Regular">
                <strong>Download your digital membership card</strong> today to access your benefits anytime, anywhere!
              </Typography>
            </Alert>

            <ButtonGroup sx={{ marginTop: '1.5rem' }}>
              {isAllowedToOrder(memberDetails?.clubCode, loggedInMember?.roleType) ? (
                <Button
                  className="request-plastic-card-button"
                  label={isSubmitting ? 'Submitting changes...' : 'Request plastic replacement card'}
                  //disabled={isSubmitting ? true : false}
                  onClick={onRequestPlasticCard}
                  fullWidth
                />
              ) : (
                <></>
              )}
              <Button
                className="download-pdf-button"
                label="Download PDF"
                onClick={onRequestPDFCard}
                variant="outlined"
                fullWidth
              />
            </ButtonGroup>
          </Stack>
        </Box>
      )}
    </Container>
  );
};
